<template>
  <iframe
    class="fullscreen-iframe"
    :class="{'loading-content': loading}"
    id="modal-fullscreen"
    :src="url"
    frameborder="0"
    allowfullscreen
    @load="onLoad"
  ></iframe>
</template>

<script>
export default {
  name: 'step-preview-iframe',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
    };
  },
  methods: {
    onLoad() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
iframe {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  min-height: calc(100vh - var(--admin-bar-height, 0px));
}

.loading-content {
  background: center / 100px no-repeat url('/wp-content/themes/snappy-theme/assets/images/loading2.gif');
}
</style>
